<template>
  <div class="current_page">
    <section>
      <!--      <div class="remainder-message" v-show="this.showRegisteredPopup">-->
      <!--        {{t('Webinar_register_success')}}-->
      <!--      </div>-->
      <button
        class="reg-btn mobile"
        v-show="!(webinarDatePassed && loggedAndActive)"
        :class="{ disabled: this.hasRegistered, hide: this.hideFixedFormBtn }"
        @click="clickOnRegisterAction"
      >
        {{ t(this.CTAText) }}
      </button>
      <div class="container adjusted-container-width">
        <div class="row">
          <div
            class="col-sm-12 col-md-7 col-lg-8 d-flex flex-column"
            id="left-col"
          >
            <TitleAndSubTitle
              :title="item.title"
              class="main-section-wrapper"
              v-if="item.hosted_by"
            >
              {{ formatedDate }} {{ item.hosted_by.name }}
            </TitleAndSubTitle>
            <div class="video-and-main-img">
              <div class="webinar-video-wrapper" v-if="showWebinarVideo">
                <iframe
                  :src="item.video.src"
                  frameborder="0"
                  allowfullscreen=""
                ></iframe>
              </div>
              <div class="main-img-wrapper" v-if="!showWebinarVideo">
                <img
                  :src="item.image"
                  alt="article image"
                  class="img-responsive"
                />
                <div class="img-opacity"></div>
                <img
                  class="play-icon"
                  src="../../../assets/play.svg"
                  @click="clickOnPlay"
                  v-show="webinarDatePassed"
                />
                <div class="countdown-wrapper" v-show="!webinarDatePassed">
                  <p>{{ t("Webinar_start_label") }}</p>
                  <VueCountdown
                    @end="webinarStarts"
                    :time="secondsUntilDate()"
                    v-if="this.item.date"
                  >
                    <template slot-scope="props">
                      <div class="counter">
                        <div class="item-wrapper">
                          <div class="days">
                            <div class="value">{{ twoDigits(props.days) }}</div>
                            <div class="title">{{ t("Webinar_days") }}</div>
                          </div>
                        </div>
                        <div class="seperator-wrapper">
                          <div class="seperator"></div>
                        </div>
                        <div class="item-wrapper">
                          <div class="hours">
                            <div class="value">
                              {{ twoDigits(props.hours) }}
                            </div>
                            <div class="title">{{ t("Webinar_Hours") }}</div>
                          </div>
                        </div>
                        <div class="seperator-wrapper">
                          <div class="seperator"></div>
                        </div>
                        <div class="item-wrapper">
                          <div class="minutes">
                            <div class="value">
                              {{ twoDigits(props.minutes) }}
                            </div>
                            <div class="title">{{ t("Webinar_Minutes") }}</div>
                          </div>
                        </div>
                        <div class="seperator-wrapper">
                          <div class="seperator"></div>
                        </div>
                        <div class="item-wrapper">
                          <div class="seconds">
                            <div class="value">
                              {{ twoDigits(props.seconds) }}
                            </div>
                            <div class="title">{{ t("Webinar_Seconds") }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </VueCountdown>
                  <button
                    class="reg-btn desktop"
                    v-show="!showWebinarVideo"
                    :class="{
                      disabled: this.hasRegistered,
                      hide: this.hideFixedFormBtn
                    }"
                    @click="clickOnRegisterAction"
                  >
                    {{ t("Webinar_Register") }}
                  </button>
                </div>
              </div>
            </div>

            <h4 class="hosted-title sub-title">{{ t("Webinar_Hosted") }}</h4>
            <div class="author-details-wrapper">
              <div class="host-img-wrapper" v-if="item.hosted_by">
                <img :src="item.hosted_by.image" class="img-responsive" />
              </div>
              <div class="author-description" v-if="item.hosted_by">
                {{ item.hosted_by.title }}
              </div>
            </div>
            <div class="description-wrapper">
              <h4 class="description-title sub-title">
                {{ t("Webinar_Description") }}
              </h4>
              <div
                id="content"
                v-html="item.description"
                class="paywall py-3 desc-content"
                :class="{ 'partially-hidden': !loggedAndActive }"
              ></div>
              <div class="content-blurrer" v-if="!loggedAndActive"></div>
            </div>
            <div
              class="login-register-wrapper"
              :class="{ messageModalActive: showMessageModal }"
            >
              <LoginOrRegister :webinarDatePassed="webinarDatePassed" />
            </div>
          </div>

          <div
            class="col-sm-12 col-md-5 col-lg-4 d-flex flex-column"
            id="section-b"
          >
            <div class="relatedAssets-wrapper" v-show="relatedAssetsExists">
              <RelatedAssets :assets="this.itemRelatedAssets" />
            </div>
            <RecommandedItems
              :title="'Webinars'"
              :recommandations="this.recommendedWebinarsFormatted"
              type="webinars"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import apiRequest from "../../../services/apiRequest";
import RelatedAssets from "@/components/relatedAssets/RelatedAssets";
import RecommandedItems from "@/components/RecommandedItems";
import LoginOrRegister from "@/components/LoginOrRegister";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import TitleAndSubTitle from "@/components/TitleAndSubTitle";
import VueCountdown from "@chenfengyuan/vue-countdown";
import {
  scrollToForm,
  elementAppearsOnScreen,
  thankYouRedirect,
  fixedBottomMessagesHeightObserver
} from "@/utils/general";

export default {
  name: "WebinarsItem",
  components: {
    RelatedAssets,
    RecommandedItems,
    LoginOrRegister,
    TitleAndSubTitle,
    VueCountdown
  },
  data() {
    return {
      item: {},
      recommendedWebinarsFormatted: [],
      hasRegistered: false,
      webinarDatePassed: false,
      // showRegisteredPopup: false,
      hideFixedFormBtn: false
    };
  },
  computed: {
    ...mapState(["itemRelatedAssets", "accountId", "isLoggedIn", "userStatusReturned"]),
    ...mapState("webinars", ["recommendedWebinars"]),
    //note: its not optimal to use 'showMessageModal' here, but it has used because this element alternates the login form's z-index which affects the message modal
    ...mapState("loginOrRegister", ["showMessageModal"]),
    ...mapGetters(["t", "baseNewApiUrl", "loggedAndActive"]),
    itemGuidAndUserStatus() {
      return `${this.item.webinar_guid}|${this.userStatusReturned}`;
    },
    webinarVideoAvailable: function() {
      //in many cases, the webinar video hasn't been uploaded by the time the webinar date was passed
      return this.webinarDatePassed && this.item.video !== null;
    },
    showWebinarVideo: function() {
      return this.loggedAndActive && this.webinarVideoAvailable;
    },
    formatedDate: function() {
      const dateAsCETtz = moment(this.item.date + "+01:00"); //treat the hard coded time as if it is CET +1
      let date = dateAsCETtz.format("DD MMM, HH:mm");
      // let timeAgo = moment(this.item.date).startOf('hour').fromNow();
      // return `${date} | ${timeAgo}`;
      return `${date} |`;
    },
    relatedAssetsExists: function() {
      return this.itemRelatedAssets && this.itemRelatedAssets.length != 0;
    },
    CTAText: function() {
      return this.webinarDatePassed ? "Watch_now_CTA" : "Webinar_Register";
    }
  },

  created() {
    this.getItem();
    this.getRecommendedWebinars().then(() => this.organizeRecommendation());
    window.addEventListener("scroll", this.handleScroll);
    fixedBottomMessagesHeightObserver();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    ResizeObserver.disconnect();
  },
  mounted() {
    this.hideComponentMountLoader();
  },

  watch: {
    itemGuidAndUserStatus() {
      if (this.isLoggedIn && this.item.webinar_guid && !this.webinarDatePassed ) {
        this.updateRegistrationStatus();
      }
    }
  },

  methods: {
    ...mapMutations([
      "incrementPendingApiCallsCount",
      "decrementPendingApiCallsCount",
      "hideComponentMountLoader",
      "setItemRelatedAssets"
    ]),
    ...mapActions("webinars", ["getRecommendedWebinars"]),
    webinarStarts() {
      this.webinarDatePassed = true;
      /*console.log("webinar starts")*/
    },
    secondsUntilDate() {
      const webinarDate = moment(this.item.date + "+01:00");
      if (webinarDate) {
        var currentDate = moment();
        var duration = moment
          .duration(webinarDate.diff(currentDate))
          .asMilliseconds();
        return duration > 0 ? duration : 0;
      }
    },
    twoDigits(value) {
      const digits = value < 10 ? `0${value}` : value;
      return digits;
    },
    async getItem() {
      this.incrementPendingApiCallsCount();
      let resp = await apiRequest.get(
        `${this.baseNewApiUrl}/webinars/${this.$route.params.id}`
      );
      this.item = await resp;
      this.decrementPendingApiCallsCount();
      this.setItemRelatedAssets(this.item.symbols);
    },
    clickOnRegisterAction() {
      if (this.loggedAndActive) {
        if (!this.hasRegistered) {
          this.registerWebinarRequest();
          thankYouRedirect();
        }
      } else {
        scrollToForm();
      }
    },
    clickOnPlay() {
      if (!this.loggedAndActive) {
        scrollToForm();
      }
    },
    organizeRecommendation() {
      this.recommendedWebinarsFormatted = [];
      const currItemFriendly = this.$route.params.id;
      this.recommendedWebinars.forEach(webinar => {
        if (webinar.friendly_url != currItemFriendly) {
          //todo futurely: if we willl receive filtered list from the server, remove this condition
          let secondaryText = window.matchMedia("(max-width: 768px)").matches
            ? webinar.hosted_by.name
            : "";
          this.recommendedWebinarsFormatted.push({
            title: webinar.title,
            text: secondaryText,
            img: webinar.image,
            item_id: webinar.friendly_url
          });
        }
      });
      this.recommendedWebinarsFormatted.reverse();
    },
    handleScroll() {
      document.getElementsByClassName("reg-btn mobile")[0].style.zIndex = 3; //needs to appear above the register form at the moment the page loads. needs to appeear behind the login popup at the end of registration
      const formElement = document
        .getElementsByClassName("login-register-wrapper")[0]
        .getElementsByClassName("form_desktop_wrap")[0];
      const footerElement = document.querySelector("footer");
      const formAppears = elementAppearsOnScreen(formElement);
      const footerAppears = elementAppearsOnScreen(footerElement);
      if (!this.loggedAndActive) {
        if (formAppears || footerAppears) {
          this.hideFixedFormBtn = true;
        } else {
          this.hideFixedFormBtn = false;
        }
      } else {
        if (footerAppears) {
          this.hideFixedFormBtn = true;
        } else {
          this.hideFixedFormBtn = false;
        }
      }
    },
    registerWebinarRequest() {
      this.incrementPendingApiCallsCount();
      let payload = { accid: this.accountId };
      apiRequest
        .post(
          `${this.baseNewApiUrl}/webinars/register/${this.item.webinar_guid}`,
          payload
        )
        .then(response => {
          this.hasRegistered = response.isRegisterd;
          // this.showRegisteredPopup=response.isRegisterd;
          this.decrementPendingApiCallsCount();
        });
    },
    updateRegistrationStatus() {
      this.incrementPendingApiCallsCount();
      let payload = { accid: this.accountId };
      apiRequest
        .post(
          `${this.baseNewApiUrl}/webinars/is-registered/${this.item.webinar_guid}`,
          payload
        )
        .then(response => {
          this.hasRegistered = response.isRegisterd;
          this.decrementPendingApiCallsCount();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.webinar-video-wrapper {
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56.25%; /* This is your aspect ratio */

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

.main-img-wrapper {
  position: relative;
}
.main-img-wrapper img {
  width: 100%;
  min-height: 300px;
}
.main-img-wrapper .img-opacity {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  background: #000000 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 0.75;
}

.main-img-wrapper .play-icon {
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 50%;
  width: 72px;
  height: 72px;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
  @media only screen and (max-width: 1000px) {
    width: 58px;
    height: 58px;
  }
  @media only screen and (max-width: 600px) {
    width: 39px;
    height: 39px;
  }
}
.countdown-wrapper {
  color: white;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    margin-bottom: 20px;
  }

  .counter {
    display: flex;
    direction: ltr;
    .seperator-wrapper {
      text-align: center;
      width: 46px;
      position: relative;

      .seperator {
        height: 20.5px;
        width: 67px;
        border-bottom: 1px solid white;
        //transform: translateY(42px) translateX(36px) rotate(105deg);
        transform: translateY(42px) rotate(105deg);
        position: absolute;
        left: 0px;
      }
    }

    .item-wrapper {
      display: flex;
      flex-direction: row;

      & > div {
        display: flex;
        flex-direction: column;
        align-items: center;

        .value {
          font-size: 2.625rem;
          font-weight: bold;
        }

        .title {
          font-size: 0.875rem;
        }
      }
    }
  }
}

ul {
  list-style: disc;
  list-style-position: inside;
}
//.remainder-message {
//  color: #FFFFFF;
//  font-size: 0.875rem;
//  background: #424242;
//  box-shadow: 0px -3px 6px #00000029;
//  width: 284px;
//  padding: 1rem 0.5rem;
//  display: flex;
//  align-items: center;
//  justify-content: center;
//
//  position: fixed;
//  left: 4rem;
//  bottom: 4rem;
//  z-index: 3;
//}

//.ar{
//  .remainder-message{
//    right: 4rem;
//    left: inherit;
//  }
//}

.relatedAssets-wrapper {
  margin-bottom: 60px;
}
.sub-title {
  font-size: 1.25rem;
}
.hosted-title {
  margin: 26px 0 14px 0;
}
.author-details-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.author-description {
  font-size: 0.875rem;
}
.host-img-wrapper {
  display: flex;
  margin-right: 1rem;
}
.host-img-wrapper img {
  width: 3rem;
  height: 3rem;
  margin-right: 0.125rem;
  object-fit: cover;
  border-radius: 50%;
}
.description-wrapper {
  position: relative;
}

button.reg-btn {
  font-weight: 500;
  background-color: #1c79be;
  color: #ffffff;
  border-radius: 3px;
  min-width: 150px;
  min-height: 40px;
  padding: 0.5rem 1rem;
  z-index: 5;
  text-align: center;
  border: none;
  outline: none;
  margin-top: 40px;
  position: relative;
  &.mobile {
    display: none;
  }
  @media only screen and (max-width: 768px) {
    position: fixed;
    bottom: calc(16px + var(--fixed-bottom-section-height));
    float: left;
    left: 50%;
    transform: translateX(-50%);
    max-width: 100%;
    &.desktop {
      display: none;
    }
    &.mobile {
      display: block;
    }
  }
}
button.reg-btn.disabled {
  background-color: #d5d3d3;
  color: #7a7c7c;
}
button.reg-btn.disabled {
  cursor: initial;
}

.desc-content.partially-hidden {
  max-height: 139px;
  overflow: hidden;
  position: relative;
}
.content-blurrer {
  height: 46px;
  width: 100%;
  position: absolute;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.8);
}

.login-register-wrapper:not(.messageModalActive) {
  z-index: 4;
}

.ar {
  .host-img-wrapper {
    margin: 0 0 0 1rem;
  }
}

@media only screen and (min-width: 600px) {
  .relatedAssets-wrapper.mobile {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  #left-col {
    padding-left: 0px;
    padding-right: 0px;

    .main-section-wrapper,
    .duration-and-lang,
    .hosted-title,
    .author-details-wrapper,
    .description-wrapper,
    .topics-wrapper {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  button.reg-btn.disabled {
    display: none;
  }
  button.reg-btn.hide {
    display: none;
  }
}
@media only screen and (max-width: 600px) {
  .description-title {
    margin-top: 24px;
    font-size: 16px;
    font-weight: bold;
  }

  .relatedAssets-wrapper.mobile {
    display: block;
  }

  .relatedAssets-wrapper.desktop {
    display: none;
  }
  .video-and-main-img {
    position: relative;
    order: 0;
    margin-bottom: 1rem;
  }

  .main-section-wrapper {
    order: 1;
  }

  .hosted-title {
    order: 4;
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1rem;
  }

  .author-details-wrapper {
    order: 5;
    margin-bottom: 1rem;
  }

  .description-wrapper {
    order: 6;
  }

  .login-register-wrapper {
    order: 7;
  }

  .topics-wrapper {
    order: 7;
  }

  .main-img-wrapper img {
    min-height: 200px;
  }

  .countdown-wrapper .counter .item-wrapper > div {
    .value {
      font-size: 2.25rem;
    }
  }

  .countdown-wrapper .counter .seperator-wrapper {
    width: 30px;
  }
  .countdown-wrapper .counter .seperator-wrapper .seperator {
    height: 20.5px;
    width: 61px;
    border-bottom: 1px solid white;
    transform: translateY(35px) rotate(105deg);
    position: absolute;
    left: -5px;
  }

  .current_page {
    padding: 0;
  }

  .field-wrapper {
    text-align: center;
  }

  .description-title {
    margin-top: 0px;
    font-size: 16px;
    font-weight: bold;
  }
  .desc-content.partially-hidden {
    max-height: 156px;
  }

  .content-blurrer {
    height: 60px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 0px;
  }

  .login-register-wrapper {
    margin-top: 0;
  }

  #section-b {
    padding-right: 0;
    padding-left: 0;
    margin-bottom: 2.5rem;
  }

  #section-b ul {
    padding-right: 15px;
    padding-left: 15px;
  }

  .sub-title {
    font-size: 1rem;
  }
  ul {
    list-style: none;
    margin-bottom: 2.75rem;
  }
  ul li::before {
    content: "\2022";
    color: #1c79be;
    font-weight: bold;
    display: inline-block;
    width: 1em;
  }

  .remainder-message {
    //top: 33.3rem;
    //position: absolute;
    top: unset;
    bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
  }

  .ar {
    .remainder-message {
      left: 0;
      right: 0;
    }
  }
}
</style>
